import styled from 'styled-components'

export const TreeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

export const TreeRow = styled.div<{ $clickable?: boolean }>`
  ${(p) => p.theme.boxContainer}
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`

export const TreeRowMain = styled.div<{ $depth: number }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1;
  padding-left: ${(p) => p.$depth * 1.5}rem;
`

export const TreeRowLabels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const ChevronWrap = styled.span<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  flex-shrink: 0;
  transform: rotate(${(p) => (p.$open ? '0deg' : '-90deg')});
  transition: transform 0.2s ease;
`

export const ChevronSpacer = styled.span`
  width: 1.25rem;
  flex-shrink: 0;
`

export const TreeRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
`
